import InstructionsImage from "../../../assets/images/BPInstructions.png";
import SiteIdImage from "../../../assets/images/SiteId.png";
import { Roles } from "../../../constants/data/Roles";
import { useAuth } from "../../../context/AuthProvider";
import "./InstructionsPage.scss";
export function InstructionsPage() {
  const auth = useAuth();
  return (
    <div
      className={`instructions-wrapper ${
        auth?.authClaims?.role === Roles.supportUser ||
        auth?.authClaims?.role === Roles.superUser
          ? "support-wrapper"
          : "admin-wrapper"
      } `}
    >
      <div className="bp-verification-support">
        <div className="instructions-info pb-2">
          In order to use Inca Evo we need to connect your patient management
          system to our service. Follow the following steps to complete this
          connection.
        </div>
        <div className="instructions-info pb-2">
          If you encounter any problems please contact our{" "}
          <span
            className="support-link"
            onClick={() => {
              window.open(process.env.REACT_APP_SUPPORT_LINK);
            }}
          >
            support team.
          </span>
        </div>
      </div>
      <div className="register-clinic verify-bp">
        <div className="instructions">
          <div className="instructions-header pb-3">
            Approve the third-party integration of Inca Evo
          </div>
          <ol>
            <li className="instructions-info pb-2">
              Open Bp Premier on your computer.
            </li>
            <li className="instructions-info pb-2">
              From the main screen navigate to
              <b>{` Setup > Configuration.`}</b> The Configuration window will
              appear.
            </li>
            <li className="instructions-info pb-2">
              Click <b>Database</b> from the icons on the lefthand side, then
              click the
              <b> Setup third-party integrations</b> button. The Setup
              third-party integrations window will appear.
            </li>
            <li className="instructions-info pb-2">
              Click in the <b>Search for</b> text box and type “Precedence
              Health Care”.
            </li>
            <li className="instructions-info pb-2">
              Tick the box next to the option
              <b> Precedence Health Care (via Halo Connect).</b>
            </li>
            <img className="pb-4 w-100" src={InstructionsImage}></img>
            <li className="instructions-info pb-2">
              Click <b>Save</b>. The Setup third-party integrations window will
              close.
            </li>
          </ol>
          <div className="instructions-header pb-3">Locate the BP Site ID</div>
          <ol>
            <li className="instructions-info pb-2">
              From the Bp Premier main screen, select <b>{`Help > About.`}</b>{" "}
              The <b>Site ID</b> field shows the <b>ID</b> for your
              installation.
            </li>
            <li className="instructions-info pb-2">
              Enter this Bp Site ID in the box below these instructions.
            </li>
            <img className="w-100" src={SiteIdImage}></img>
          </ol>
          <div className="instructions-header pb-3">Locate the Halo GUID</div>
          <ol>
            <li className="instructions-info pb-2">
              From the Windows search menu, search for <b>“Registry Editor” </b>
              and open the program.
            </li>
            <li className="instructions-info pb-2">
              On the top toolbar, click <b>Edit</b> and select <b>Find…</b>.
            </li>
            <li className="instructions-info pb-2">
              Type “<b>HaloGuids</b>” in the search bar, and click{" "}
              <b>Find Next</b>.
            </li>
            <li className="instructions-info pb-2">
              The <b>HaloGuids</b> field shows the Halo GUID for your
              installation.
            </li>
            <li className="instructions-info pb-2">
              Right click on that field, click <b>Modify…</b>.
            </li>
            <li className="instructions-info pb-2">
              In the popup, select and <b>copy</b> the Halo GUID from the text
              box labelled “Value data”, <b>paste</b> it into the Halo GUID
              field below.
            </li>
            <video width="320" height="240" controls>
              <source
                src={process.env.REACT_APP_HALOGUID_VIDEO_URL}
                type="video/mp4"
              />
              Your browser does not support the video tag.
            </video>
          </ol>
        </div>
      </div>
    </div>
  );
}
